import { hasQuery } from './hasQuery'
export const isPreview = () => hasQuery('preview', '1')
export const isEmbed = () => hasQuery('embed', '1')
export const isReschedule = () => hasQuery('rs', 'any')
export const isDefault = () => !isEmbed() && !isPreview()
export const isEdit = () => hasQuery('edit', '1')
// `?hideImportantNotice=1` 等が付いているとき、重要なお知らせモーダルの表示を抑制する。
// スクリーンショット撮影や埋め込み・プレビューなどで邪魔にしたくないケース向け。
export const isImportantNoticeHidden = () =>
  hasQuery('hideImportantNotice', 'any') || isPreview() || isEmbed()
